export default __webpack_public_path__ + "static/media/Metropolis-RegularItalic.6f16ffe9.otf";